import * as React from "react"

const SvgComponent = (props) => (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clip-path="url(#clip0_40435_2730)">
        <path d="M31.4232 5.49805L13.1665 5.49805C11.5053 5.49805 10.0748 7.0742 9.98448 9.0022L7.00437 34.7039C6.91527 36.6305 8.20052 38.2081 9.86049 38.2081C11.7 38.2081 8.62272 38.2095 15.2966 38.2095H28.1233C29.7833 38.2095 31.215 36.6333 31.3041 34.7053L34.2854 9.00787C34.3746 7.07846 33.0869 5.49947 31.4244 5.49947L31.4232 5.49805Z" fill="#4F87FF"/>
        <path d="M35.0111 8.78711H16.438C14.7768 8.78711 13.3463 10.3633 13.256 12.2913L10.2759 37.993C10.1868 39.9195 11.472 41.4971 13.132 41.4971C14.9715 41.4971 11.8942 41.4985 18.568 41.4985H34.4549C36.1149 41.4985 37.5466 39.9224 37.6357 37.9944L40.6213 14.4531L35.5211 8.78711H35.0111Z" fill="#4F87FF" stroke="white"/>
        <path d="M35.011 8.8418L34.7772 11.6478C34.6285 13.4319 36.0364 14.962 37.8267 14.962H40.6212" stroke="white"/>
        <path d="M16 37.5L16.5 33.5" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M18 37.5L18.5 33.5" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M20 37.5L20.5 33.5" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M22 37.5L22.5 33.5" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M25 37.5H33" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
        <clipPath id="clip0_40435_2730">
        <rect width="36" height="37" fill="white" transform="translate(6 5.5)"/>
        </clipPath>
        </defs>
    </svg>
    );

export default SvgComponent;